// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PcqM","newExpiryDate":"styles_newExpiryDate__pwGfy","footer":"styles_footer__20I6l"};